const RenderTable = () => {
  let width = window.innerWidth
  return (
    <div className="gearstable-content">
      <table className="gearstable-content__title">
        <tr>
          <th colSpan="6">Velorbis bicycle Gents frames size guide</th>
        </tr>
      </table>
      <div className="gearstable-content__flexible">
        <table>
          <thead>
            <tr>
              <th colSpan="2">Your height</th>
            </tr>
            <tr>
              <th>Feet & Inches</th>
              <th>{width > 530 ? 'Centimeters' : 'Cm'}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>5ft 6&quot;- 5ft 9&quot;</td>
              <td>167-174</td>
            </tr>
            <tr>
              <td>5ft 9&quot;- 6ft 3&quot;</td>
              <td>175-190</td>
            </tr>
            <tr>
              <td>6ft 3&quot;- 6ft 9&quot;</td>
              <td>191-206</td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th colSpan="3">Suggested frame size</th>
            </tr>
            <tr>
              <th>{width > 530 ? 'Inches' : '"'}</th>
              <th>{width > 530 ? 'Centimeters' : 'Cm'}</th>
              <th>Wheel size</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>21</td>
              <td>54</td>
              <td>28&quot;</td>
            </tr>
            <tr>
              <td>22</td>
              <td>57</td>
              <td>28&quot;</td>
            </tr>
            <tr>
              <td>24</td>
              <td>61</td>
              <td>28&quot;</td>
            </tr>
          </tbody>
        </table>
      </div>
      <table className="gearstable-content__title">
        <tr>
          <th colSpan="6">Velorbis bicycle Ladies frame size guide</th>
        </tr>
      </table>
      <div className="gearstable-content__flexible">
        <table>
          <thead>
            <tr>
              <th colSpan="2">Your height</th>
            </tr>
            <tr>
              <th>Feet & Inches</th>
              <th>{width > 530 ? 'Centimeters' : 'Cm'}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>4ft 11&quot;- 5ft 3&quot;</td>
              <td>150-162</td>
            </tr>
            <tr>
              <td>5ft 2&frac12;&quot;- 5ft 7&frac12;&quot;</td>
              <td>160-172</td>
            </tr>
            <tr>
              <td>5ft 6&quot;- 5ft 10&quot;</td>
              <td>167-179</td>
            </tr>
            <tr>
              <td>5ft 10&quot;+</td>
              <td>180+</td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th colSpan="3">Suggested frame size</th>
            </tr>
            <tr>
              <th>{width > 530 ? 'Inches' : '"'}</th>
              <th>{width > 530 ? 'Centimeters' : 'Cm'}</th>
              <th>Wheel size</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>18</td>
              <td>45</td>
              <td>26&quot;</td>
            </tr>
            <tr>
              <td>20</td>
              <td>50</td>
              <td>28&quot;</td>
            </tr>
            <tr>
              <td>21 &frac12;</td>
              <td>55</td>
              <td>28&quot;</td>
            </tr>
            <tr>
              <td>23</td>
              <td>60</td>
              <td>28&quot;</td>
            </tr>
          </tbody>
        </table>
      </div>
      <table className="gearstable-content__title">
        <tr>
          <th colSpan="6">Velorbis bicycle Girls frame size guide</th>
        </tr>
      </table>
      <div className="gearstable-content__flexible">
        <table>
          <thead>
            <tr>
              <th colSpan="2">Your height</th>
            </tr>
            <tr>
              <th>Feet & Inches</th>
              <th>{width > 530 ? 'Centimeters' : 'Cm'}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>3ft 11&quot;- 4ft 6&quot;</td>
              <td>120-138</td>
            </tr>
            <tr>
              <td>4ft 3&quot;- 4ft 11&quot;</td>
              <td>130-150</td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th colSpan="3">Suggested frame size</th>
            </tr>
            <tr>
              <th>{width > 530 ? 'Inches' : '"'}</th>
              <th>{width > 530 ? 'Centimeters' : 'Cm'}</th>
              <th>Wheel size</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>14</td>
              <td>35</td>
              <td>20&quot;</td>
            </tr>
            <tr>
              <td>16</td>
              <td>40</td>
              <td>24&quot;</td>
            </tr>
          </tbody>
        </table>
      </div>
      <table className="gearstable-content__title">
        <tr>
          <th colSpan="6">Velorbis bicycle Boys frame size guide</th>
        </tr>
      </table>
      <div className="gearstable-content__flexible">
        <table>
          <thead>
            <tr>
              <th colSpan="2">Your height</th>
            </tr>
            <tr>
              <th>Feet & Inches</th>
              <th>{width > 530 ? 'Centimeters' : 'Cm'}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>4ft &frac12;&quot;- 4ft 7&frac12;&quot;</td>
              <td>123-141</td>
            </tr>
            <tr>
              <td>3ft 11&quot;- 4ft 6&quot;</td>
              <td>133-155</td>
            </tr>
          </tbody>
        </table>
        <table>
          <thead>
            <tr>
              <th colSpan="3">Suggested frame size</th>
            </tr>
            <tr>
              <th>{width > 530 ? 'Inches' : '"'}</th>
              <th>{width > 530 ? 'Centimeters' : 'Cm'}</th>
              <th>Wheel size</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>15</td>
              <td>28</td>
              <td>20&quot;</td>
            </tr>
            <tr>
              <td>17</td>
              <td>43</td>
              <td>24&quot;</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default RenderTable
